import { useState } from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const menuItems = [
  { label: 'Eventos', href: '/events', icon: '📅' },
  { label: 'Usuarios', href: '/users', icon: '👥' },
  { label: 'Estaciones', href: '/stations', icon: '📍' },
  { label: 'Preguntas', href: '/questions', icon: '❓' },
  { label: 'Agenda', href: '/agendas', icon: '📋' },
  { label: 'Temas', href: '/topics', icon: '📌' },
  { label: 'Ponentes', href: '/speakers', icon: '🎤' },
  { label: 'Promociones', href: '/promotions', icon: '🎁' },
  { label: 'Encuestas', href: '/surveys', icon: '📊' },
  { label: 'Diseño Visual', href: '/design', icon: '🎨' },
];

function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      <aside
        className={`${
          sidebarOpen ? 'w-64' : 'w-20'
        } bg-slate-800 text-white transition-all duration-200 flex flex-col`}
      >
        <div className="p-4 flex items-center justify-between border-b border-slate-700">
          {sidebarOpen && <span className="font-bold">Admin</span>}
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="p-1 rounded hover:bg-slate-700"
          >
            {sidebarOpen ? '◀' : '▶'}
          </button>
        </div>
        <nav className="flex-1 p-2 overflow-y-auto">
          {menuItems.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-slate-700 mb-1"
            >
              <span>{item.icon}</span>
              {sidebarOpen && <span>{item.label}</span>}
            </Link>
          ))}
        </nav>
        <div className="p-4 border-t border-slate-700">
          {sidebarOpen && (
            <div className="mb-2 text-sm text-slate-300 truncate">{user?.email}</div>
          )}
          <button
            onClick={handleLogout}
            className="w-full py-2 px-3 rounded bg-slate-600 hover:bg-slate-500 text-sm"
          >
            {sidebarOpen ? 'Cerrar sesión' : '🚪'}
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <div className="p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export default Layout;
